<template>
  <el-dialog title="调整收益金" class="global-dialog" :visible.sync="showDlg" width="400px" :before-close="handleClose">

    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        :rules="rules" ref="form2" label-width="100px">
        <el-row>

          <el-col :span="24">
            <el-form-item prop="amountChange" label="变动金额">
              <el-input placeholder="请输入变动金额" v-model="formData.amountChange">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="changeReason" label="变动原因">
              <el-input type="textarea" placeholder="请输入变动原因" v-model="formData.changeReason">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>

  </el-dialog>
</template>
<script>

export default {
  props: {

    showDlg: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: ''
    }
  },

  data () {
    const checkNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入变动金额'))
      }
      const reg = /^-?\d+(\.\d+)?$/
      if (!reg.test(value)) {
        return callback(new Error('变动金额为数字、小数、负数'))
      }
      return callback()
    }
    return {

      formData: {
        amountChange: '',
        userId: ''

      },
      rules: {
        amountChange: [
          {
            required: true,
            message: '请输入变动金额',
            trigger: ['blur', 'change']
          },
          { validator: checkNum, trigger: 'blur' }
        ],
        changeReason: [
          {
            required: true,
            message: '请输入变动原因',
            trigger: ['blur', 'change']
          }
        ]

      },
      loading: false
    }
  },

  methods: {

    submitDlg () {
      this.$refs.form2.validate().then(() => {
        console.log(this.formData)
        this.loading = true
        const url = this.$apis.userBond.insertYxUserDepositRecord
        this.$axios.post(url, { ...this.formData, userId: this.userId }).then(() => {
          this.$emit('successSave')
          this.handleClose()
        }).finally(() => {
          this.loading = false
        })
      })
    },
    handleClose() {
      this.$emit('update:showDlg', false)
    }
  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
